mutation disconnectXero {
  disconnectXero {
    __typename
    isTokenSetValid
  }
} 